import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { SetupService } from './services/setup/setup.service';
import { DataStoreService } from './services/data-store/data-store.service';
import { EndpointService } from './services/endpoint/endpoint.service';
import { BafAgentService } from './services/baf-agent/baf-agent.service';

@NgModule({
  imports: [CommonModule, HttpClientModule],
  providers: [SetupService, DataStoreService, EndpointService, BafAgentService]
})
export class CoreModule {}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts